import { createAction } from '@reduxjs/toolkit';

import type { ServerModel } from 'Modules/serverApi/types';

export const setProductData = createAction<ServerModel.SearchItem>('SET_PRODUCT_DATA');
